export const getCircularIndexByOffset = <T>(
  arr: T[],
  current: number,
  diff: number
) => {
  let newIndex = (current + diff) % arr.length;

  if (newIndex < 0) newIndex = arr.length + newIndex;

  return Math.abs(newIndex);
};

export function notEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}

export const filterUnique = <T>(arr: T[]) => {
  return arr.filter((item, i) => {
    return arr.indexOf(item) === i;
  });
};
